module.exports = "::ng-deep .modal-content {\n    /*  the (semi-transparent) border styling of modal-content causes a 1px white strip on      */\n    /*  the right side of the WARNING header, but width:101% fixes it while keeping the border  */\n    width: 101%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/uninstall-services-confirmation/uninstall-services-confirmation.modal.component.css
// module id = 913
// module chunks = 4